var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { parse } from 'query-string';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { SubmissionError } from 'redux-form';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { apiCreateUserRegistration } from '../../../actions/UserActions';
import { REQUEST_DIVISION_CANDIDATE_CLIENT, REQUEST_DIVISION_CANDIDATE_PRO, } from '../../../define/consts/registration';
import { BAD_DIVISION_CLIENT, BAD_DIVISION_PROFESSIONAL, } from '../../../define/response';
import { wrapDispatch } from '../../../helpers/action';
import { propChildren, propFunc, propStr, } from '../../../helpers/custom-prop-types';
import { createValidateErrorData } from '../../../helpers/validate';
import { bind as bindAuthKana } from '../../../vendor/AutoKana';
import FormRegistrationInner from './FormRegistrationInner';
const FormRegistration = (props) => {
    const { newHeaderDescription, newHeaderTitle, onSubmitAfter, registrationType, requestDivisionLabelName, submitEvent, } = props;
    const dispatch = useDispatch();
    const { search } = useLocation();
    const history = useNavigate();
    const kanaRef = useRef({ first: null, last: null });
    useEffect(() => {
        const lastKana = bindAuthKana('#lastName', '');
        const firstKana = bindAuthKana('#firstName', '');
        kanaRef.current.last = lastKana;
        kanaRef.current.first = firstKana;
        return () => {
            lastKana.removeEvents();
            firstKana.removeEvents();
        };
    }, [kanaRef]);
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        if (submitEvent) {
            submitEvent();
        }
        // 遷移元から渡された値を取得
        const { ref, type } = parse(search);
        const setFields = Object.assign(Object.assign({}, values), { first_name_kana: kanaRef.current.first.getFurigana(), last_name_kana: kanaRef.current.last.getFurigana(), registrationType: type || registrationType, registrationUrl: ref, requestDivision: parseInt(values.requestDivision, 10) });
        const action = apiCreateUserRegistration(setFields);
        try {
            yield wrapDispatch(dispatch, action);
        }
        catch (e) {
            const clientName = REQUEST_DIVISION_CANDIDATE_CLIENT.name[requestDivisionLabelName];
            const proName = REQUEST_DIVISION_CANDIDATE_PRO.name[requestDivisionLabelName];
            const errorMessage = createValidateErrorData(e, {
                [BAD_DIVISION_CLIENT]: {
                    key: 'requestDivision',
                    message: `コンサルタントの方は「${proName}」をご選択ください`,
                },
                [BAD_DIVISION_PROFESSIONAL]: {
                    key: 'requestDivision',
                    message: `クライアントの方は「${clientName}」をご選択ください`,
                },
            });
            throw new SubmissionError(errorMessage);
        }
        if (onSubmitAfter) {
            onSubmitAfter(setFields);
        }
        else {
            const redirect = setFields.requestDivision === 1
                ? 'complete_client'
                : 'complete_consultant';
            history.push(`/registration/${redirect}`);
        }
    }), [
        dispatch,
        onSubmitAfter,
        registrationType,
        requestDivisionLabelName,
        search,
        submitEvent,
        history,
    ]);
    return (_jsx(FormRegistrationInner, { newHeaderDescription: newHeaderDescription, newHeaderTitle: newHeaderTitle, onSubmit: onSubmit, onSubmitAfter: onSubmitAfter, requestDivisionLabelName: requestDivisionLabelName }));
};
FormRegistration.propTypes = {
    newHeaderDescription: propChildren(),
    newHeaderTitle: propChildren(),
    onSubmitAfter: propFunc(),
    registrationType: propStr().isRequired,
    requestDivisionLabelName: propStr().isRequired,
    submitEvent: propFunc(),
};
FormRegistration.defaultProps = {
    newHeaderDescription: undefined,
    newHeaderTitle: undefined,
    onSubmitAfter: undefined,
    submitEvent: undefined,
};
export default FormRegistration;
